import { effectiveExecutionProfile } from "./effectiveExecutionProfile";
import { isSetPerformed } from "./executionUi";

function numericOrder(value, fallback = Number.MAX_SAFE_INTEGER) {
  return Number.isInteger(value) ? value : fallback;
}

export function orderGroupItems(items = []) {
  return items
    .map((item, sourceIndex) => ({ item, sourceIndex }))
    .sort((left, right) =>
      numericOrder(left.item.laneIndex) - numericOrder(right.item.laneIndex) ||
      numericOrder(left.item.position) - numericOrder(right.item.position) ||
      left.sourceIndex - right.sourceIndex
    )
    .map(({ item }) => item);
}

// Structural rounds are the union of existing setIndex values across lanes;
// nothing is fabricated for uneven lanes. A skipped lane stays structurally
// present (its sets remain in `laneSets`) but is not actionable, so it never
// blocks completion (§14.1). A round is `complete` when it has no remaining
// actionable work; a round held only by skipped lanes is therefore complete
// with `actionableCount === 0` (it is not a blocker, and it has no anchor).
export function deriveGroupRounds(record, items = []) {
  const rounds = new Map();
  const rirEnabled = record?.server?.policy?.rirInputEnabled !== false;

  orderGroupItems(items).forEach((item) => {
    const profile = effectiveExecutionProfile(record, item);
    const skipped = Boolean(item.skipped);
    (item.sets || []).forEach((set) => {
      if (!Number.isInteger(set.setIndex)) return;
      if (!rounds.has(set.setIndex)) rounds.set(set.setIndex, []);
      rounds.get(set.setIndex).push({
        itemId: item.itemId,
        setId: set.setId,
        skipped,
        actionable: !skipped,
        performed: isSetPerformed(profile, set, rirEnabled),
      });
    });
  });

  return Array.from(rounds, ([setIndex, laneSets]) => {
    const actionable = laneSets.filter((set) => set.actionable);
    return {
      setIndex,
      laneSets,
      actionableCount: actionable.length,
      complete: actionable.every((set) => set.performed),
    };
  }).sort((left, right) => left.setIndex - right.setIndex);
}
